import { consola } from 'consola';

export const logger = consola.withTag('app');
